import { Icon } from '@chakra-ui/react';

export default function LineChartIcon(props) {
  return (
    <Icon
      width='18px'
      height='15px'
      viewBox='0 0 18 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M0.601562 14.0156V0.8125C0.601562 0.476562 0.882812 0.1875 1.23438 0.1875C1.57812 0.1875 1.85938 0.476562 1.85938 0.8125V7.78906L4.29688 5.32031C4.65625 4.96094 4.98438 4.80469 5.35156 4.80469C5.71875 4.80469 6.0625 4.96875 6.40625 5.32031L9.28125 8.26562C9.35156 8.33594 9.42969 8.375 9.49219 8.375C9.5625 8.375 9.64062 8.33594 9.71094 8.26562L12.7891 5.14844L11.5 3.85938C11.2188 3.57812 11.3906 3.21875 11.7891 3.10938L16.3594 1.96094C16.7109 1.86719 17.0234 2.16406 16.9297 2.52344L15.7734 7.10156C15.6719 7.5 15.3047 7.67188 15.0234 7.39062L13.7422 6.10156L10.5547 9.30469C10.2031 9.65625 9.86719 9.82031 9.49219 9.82031C9.125 9.82031 8.77344 9.65625 8.4375 9.30469L5.5625 6.35938C5.49219 6.28906 5.42188 6.25 5.35156 6.25C5.28125 6.25 5.21094 6.28906 5.14062 6.35938L1.85938 9.70312V13.1641C1.85938 13.3281 1.91406 13.3828 2.07812 13.3828H16.7656C17.1094 13.3828 17.3984 13.6641 17.3984 14.0078C17.3984 14.3594 17.1094 14.6328 16.7656 14.6328H1.22656C0.851562 14.6328 0.601562 14.3906 0.601562 14.0156Z' />
    </Icon>
  );
}
